import * as React from 'react';

export const TranslationsContext = React.createContext({});

interface TranslationsContextProps {
  translate: any;
  children: React.ReactNode;
}

export function TranslationsContextProvider({
  translate,
  children
}: TranslationsContextProps) {
  return (
    <TranslationsContext.Provider value={translate}>
      {/* force line for readability */}
      {children}
    </TranslationsContext.Provider>
  );
}
